import { absolutePath } from "./absolutePath";

interface NextPlanWithFeatureFnProps {
  params?: Record<string, unknown> | unknown[];
  planId?: string;
}

export const nextPlanWithFeature = {
  show: ({ planId, params = {} }: NextPlanWithFeatureFnProps = {}) =>
    absolutePath(`communities/plans/${planId}/next_plan_with_features`, params),
};
